import { ConnectedPosition } from '@angular/cdk/overlay';

import { Observable } from 'rxjs';

import { KeyboardEventCode } from '@recruitee/user-interface';

import { EditorEvent, OverlayPosition } from '../../editor/types';

export enum MentionType {
  User = 'user',
  Role = 'role',
}

export interface MentionElement<T = any> {
  id: number;
  type: MentionType;
  name: string;
  avatar: string;
  entity?: T;
}

export type MentionNavigationKey =
  | KeyboardEventCode.ArrowUp
  | KeyboardEventCode.ArrowDown
  | KeyboardEventCode.Enter;

export abstract class MentionsPluginEvent extends EditorEvent {
  protected constructor(type: string) {
    super('EmojiPlugin', type);
  }
}

export class MentionsPluginPickerBeforeOpen extends MentionsPluginEvent {
  constructor() {
    super('pickerOpen');
  }
}

export class MentionsPluginPickerClose extends MentionsPluginEvent {
  constructor() {
    super('pickerClose');
  }
}

export type MentionsPluginEvents = MentionsPluginPickerBeforeOpen | MentionsPluginPickerClose;

export interface MentionsListOpenOptions {
  withSearch?: boolean;
  preferredPositions?: ConnectedPosition[];
  queryChange?: (value: string) => void;
}

export interface MentionListController {
  open: (
    position: OverlayPosition,
    options?: MentionsListOpenOptions,
  ) => { element: HTMLElement; backdropClick$: Observable<MouseEvent> };
  setData: (data: MentionElement[]) => void;
  setSelectCallback: (selectCb: (val: MentionElement) => void) => void;
  close: () => void;
  updatePosition: (position: OverlayPosition) => void;
  isOpen: () => boolean;
  handleKey: (key: MentionNavigationKey) => void;
}
